import { z } from "zod";

export const invoiceFormSchema = z.object({
  billFrom: z
    .string()
    .min(1, "Bill From is required"),

  billTo: z
    .string()
    .min(1, "Bill To is required"),

  invoiceNo: z
    .string()
    .min(1, "Invoice number is required"),

  date: z
    .string()
    .min(1, "Invoice date is required"),

  paymentTerms: z
    .string()
    .min(1, "Payment terms are required"),

  dueDate: z
    .string()
    .min(1, "Due date is required"),

  poNumber: z
    .string()
    .min(1,"PO Number is required"),

  notes: z
    .string()
    .optional(),

  terms: z
    .string()
    .optional(),

  bank: z
    .string()
    .min(1, "Bank is required"),

  tax: z
    .number()
    .optional(),

  shipping: z
    .number()
    .optional(),

  discount: z
    .number()
    .optional(),

  amountPaid: z
    .number({
      required_error: "Amount paid is required",
      invalid_type_error: "Amount paid must be a number",
    })
    .min(0, "Amount paid cannot be negative"),

  balanceDue: z
    .string()
    .min(1, "Balance due is required"),

  items: z
    .array(
      z.object({
        description: z
          .string()
          .min(1, "Item description is required"),

        quantity: z
          .number({
            required_error: "Quantity is required",
            invalid_type_error: "Number is required",
          })
          .min(1, "Quantity is required"),

        rate: z
          .number({
            required_error: "Rate is required",
            invalid_type_error: "Number is required",
          })
          .min(1, "Required"),
      })
    )
    .min(1, "Number is required"),
});
export type InvoiceForm = z.infer<typeof invoiceFormSchema>;